<template>
  <footer class="footer">
    <div class="container">
      <nav class="level">
        <div class="level-left">
          <ul>
            <li>
              <i class="fa fa-phone" aria-hidden="true"></i>
              (+54 - 11) 15-5149-6996
            </li>
            <li>
              <i class="fa fa-envelope" aria-hidden="true"></i>
              contacto@nelsoniranch.com.ar
            </li>
            <li>
              <a href="https://www.facebook.com/NelsoniRanch" target="_blank">

                <i class="fa fa-facebook-official" aria-hidden="true"></i>
                NelsoniRanch
              </a>
            </li>
          </ul>
        </div>
        <div class="level-right">
          <span class="icon-logoNelsoniRanch_blanco"></span>
        </div>
      </nav>
    </div>
  </footer>
</template>
<script>

export default {
  name: 'footer'
}
</script>
<style lang="scss" scoped>
$green:#7cb542;
.icon-logoNelsoniRanch_blanco:before {
  content: "\e900";
  color: #fff;
  font-size: 5em;
}

footer {
  background: black;
  ul li, a {
    color: white;
    i {
      color: $green;
      padding-right: 5px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/footer.vue